import React, { useEffect, useRef } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { usePostQuery } from "../../hooks/reactQueryHelper";
import { AddContactInquiry } from "../../services/Web.type";
import toastify from "../../helper/toastify";
import Loader from "../../Common/loader/Loader";
import SpinnerLoader from "../../Common/loader/SpinnerLoder";

const ContactUs = () => {
  const initialValues = {
    name: "",
    email: "",
    description: " ",
  };

  const validationSchema = Yup.object({
    name: Yup.string().trim().required("Please enter name"),
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Please enter email address"),
    description: Yup.string().trim().required("Please enter your description"),
  });

  const contactUsQuery = usePostQuery("contactUsQuery", AddContactInquiry, {});

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    const newRecord = {
      name: values.name,
      email: values.email,
      description: values.description,
    };
    contactUsQuery.mutate(newRecord);
    resetForm();
    setSubmitting(false);
  };

  const ref = useRef(null);
  const handleStartHere = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };
  const handlekeypresschanges = (event)=>{
    let keySign= event.key; 
    if(keySign==="<" || keySign===">")
        event.preventDefault();
};

  useEffect(() => {
    if (contactUsQuery.isSuccess) {
      toastify("success", "Your inquiry has been sent successfully");
    }
  }, [contactUsQuery.isSuccess]);

  return (
    <>
      <main>
        <Loader loading={contactUsQuery?.isLoading} />
        <section className="section-header-padding">
          <Container>
            <Row>
              <Col className="col-12">
                <h1 className="bebas-neue-font text-default-color py-4 text-center">
                  CONTACT US
                </h1>
              </Col>
            </Row>
          </Container>
        </section>
        <section id="help_details" className="help-details">
          <Container className="contact-form-margin">
            <Row className="align-items-center justify-content-center justify-content-evenly">
              <Col lg={7}>
                <div className="mb-3">
                  <img
                    className="img-fluid"
                    src="\media\assets\contact-us\frame.png"
                    alt="..."
                  />
                </div>
              </Col>
              <Col lg={5} className="col-12">
                <div className="px-4">
                  <h2 className="text-start lh-1 mb-4 plus-jakarta-sans-font">
                    We are here to help you
                  </h2>
                  <p className="text-start lead fw-normal text-muted mb-5 mb-lg-4 plus-jakarta-sans-font">
                    Lorem ipsum dolor sit amet consectetur. At commodo sagittis
                    neque neque posuere. Non lorem fringilla at augue sagittis
                    vel lorem mattis tempor.
                  </p>
                  <div className="plus-jakarta-sans-font d-grid text-start gap-3 d-sm-flex justify-content-sm-center justify-content-xxl-start mb-3">
                    <button
                      className="btn default-border-color px-4 py-2 fs-6 rounded-pill fw-bolder"
                      type="submit"
                      ref={ref}
                      onClick={handleStartHere}
                    >
                      Start Here
                    </button>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section
          id="contact_form"
          className="contact-form bg-default bg-mbs-default"
        >
          <Container className="position-relative setmargin">
            <Row>
              <Col
                md={6}
                lg={6}
                xs={12}
                className="p-4 order-md-1 order-1 colorset detail-bottom"
              >
                <div className="text-start tab-form-w-75 tab-form-view">
                  <h1 className="bebas-neue-font">LET'S CHAT.</h1>
                  <p className="plus-jakarta-sans-font">
                    Lorem ipsum dolor sit amet consectetur. Volutpat tincidunt
                    ultricesm at orci eleifend adipiscing pretium. Vestibulum
                    convallis quam massa elit aliquam tortor dictumst turpis.
                    Adipiscing dictum feugiat aliquam quis tortor sit
                    suspendisse leo tristique. Fermentum blandit mattis volutpat
                    mi sollicitudin elementum venenatis.
                  </p>
                  <h1 className="bebas-neue-font">EMAIL</h1>
                  <p className="plus-jakarta-sans-font">
                    movesupport@gmail.com
                  </p>
                </div>
              </Col>
              <Col
                md={5}
                lg={4}
                xs={12}
                className="form-bg form-position form-max-height form-padding rounded-4 order-md-2 order-1 end-0 py-5 px-5 shadow contactForm"
                style={{
                  position: "absolute",
                  maxHeight: "464px",
                }}
              >
                <div className="" style={{ maxHeight: "400px" }}>
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                  >
                    {({
                      touched,
                      errors,
                      handleChange,
                      handleBlur,
                      getFieldProps,
                      handleSubmit,
                    }) => {
                      return (
                        <Form onSubmit={handleSubmit} ref={ref} noValidate>
                          <Form.Group className="mb-3 text-start " controlId="">
                            <Form.Label>
                              Name<span style={{ color: "red" }}>*</span> :
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your Name"
                              {...getFieldProps("name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`rounded-pill form-control ${
                                errors.name && touched.name
                                  ? "border border-danger mb-0"
                                  : ""
                              }`}
                            />
                          </Form.Group>
                          <Form.Group
                            className="mb-3 text-start "
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>
                              Email<span style={{ color: "red" }}>*</span> :
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter your email"
                              {...getFieldProps("email")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`rounded-pill form-control ${
                                errors.email && touched.email
                                  ? "border border-danger mb-0"
                                  : ""
                              }`}
                            />
                          </Form.Group>
                          <Form.Group
                            className="mb-3 text-start "
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label>
                              Message<span style={{ color: "red" }}>*</span> :
                            </Form.Label>
                            <Form.Control
                              type="text"
                              as="textarea"
                              placeholder="Enter your description"
                              rows={5}
                              {...getFieldProps("description")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              onKeyPress={handlekeypresschanges}
                              className={`rounded-4 form-control ${
                                errors.description && touched.description
                                  ? "border border-danger mb-0"
                                  : ""
                              }`}
                              style={{ resize: "none" }}
                            />
                          </Form.Group>
                          <Button
                            type="submit"
                            className="btn-default px-5 w-100 rounded-pill border-0"
                          >
                            {contactUsQuery?.isLoading ? (
                              <SpinnerLoader
                                loading={contactUsQuery?.isLoading}
                              />
                            ) : (
                              "Send Message"
                            )}
                          </Button>
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
};

export default ContactUs;
